
import { tagableMixin } from "~/mixins";

const WIDTH = "1024";
const HEIGHT = "767";
/** PDP grid: desktop gallery `lg:w-2/3`, mobile full viewport width (`lg:hidden` column). Matches `lg:` (1024px). */
const HERO_SIZES = "(min-width: 1024px) 66vw, 100vw";

export default {
  mixins: [tagableMixin],

  props: {
    images: { type: Array, required: true },
    threeDUrl: { type: String, default: "" },
    sku: { type: String, default: "" },
    tags: { type: Array, default: () => [] },
    /** Distinct Swiper root when multiple PDP galleries mount (desktop vs mobile columns) */
    instanceKey: { type: String, default: "" },
    /**
     * When true, first hero slide stays `loading="lazy"` (no `fetchpriority`) so duplicate galleries can defer to `<link rel="preload">`.
     * Product PDP leaves this false so LCP `<img>` is eager + high priority (same CDN URL dedupes across mobile/desktop instances).
     */
    deferHeroFetch: { type: Boolean, default: false },
    /** Fallback/accessibility text when hero image lacks `altText`. */
    imageAlt: { type: String, default: "" },
  },

  data: () => ({ renderStylefit: false }),

  computed: {
    hasMoreImages() {
      return this.images?.length > 1;
    },
  },

  watch: {
    sku(newSku, oldSku) {
      if (newSku !== oldSku) {
        this.renderStylefit = false;
      }
    },
  },

  methods: {
    getImageOptions(image, isFirstImage = false) {
      const alt = image?.altText || this.imageAlt || "";

      const options = {
        src: image?.w_1024_h_767,
        webpSrc: image?.w_1024_h_767_webp,
        widths: [WIDTH],
        width: WIDTH,
        height: HEIGHT,
        sizes: HERO_SIZES,
        alt,
      };
      if (isFirstImage && !this.deferHeroFetch) {
        options.fetchpriority = "high";
        options.loading = "eager";
      }
      return options;
    },
    async onImageClick(index) {
      try {
        const { openImageZoom } = await import("~/utils/photoswipe.client");

        const zoomImages = this.images.map(image => {
          const width = Number(image.width) || Number(WIDTH);
          const height = Number(image.height) || Number(HEIGHT);

          return {
            src: image.src || image.originalSrc || image.w_1024_h_767,
            width,
            height,
          };
        });

        openImageZoom(zoomImages, index);
      } catch (error) {
        this.$bugsnag.notify(error);
      }
    },
  },
};
